/* istanbul ignore file */

import type { SVGProps } from 'react';
import { useTheme } from 'styled-components';

type Props = SVGProps<SVGSVGElement> & {
    mode: 'light' | 'dark';
};

export default function EValueOneToTenIcon({ mode, ...props }: Props) {
    const theme = useTheme();

    return (
        <svg
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="82"
            height="30"
            viewBox="0 0 82 30"
            {...props}
            role="img"
        >
            <g>
                <path
                    fill="#32D8D2"
                    d="M45.682.703c-2.078 0-4.107.64-5.818 1.837a10.377 10.377 0 0 0-3.762 4.86l-4.263 11.336-3.562-9.43C26.76 5.277 22.35 1.4 17.919.736l10.212 27.154h7.416L45.76.735l-.077-.032Z"
                />
                <path
                    fill="#FF4792"
                    d="M26.582 19.658a16.611 16.611 0 0 0-7.907 1.922 7.396 7.396 0 0 1-3.524.89 7.439 7.439 0 0 1-4.033-1.191 7.59 7.59 0 0 1-2.773-3.2l20.631.04a14.58 14.58 0 0 0-.741-8.864A14.41 14.41 0 0 0 25.07 4.54a14.178 14.178 0 0 0-4.722-3.097A14.02 14.02 0 0 0 14.81.45a14.153 14.153 0 0 0-9.683 4.228 14.553 14.553 0 0 0-4.168 9.821c-.046 1.92.287 3.83.98 5.617a14.424 14.424 0 0 0 3.054 4.79 14.191 14.191 0 0 0 4.647 3.21 14.024 14.024 0 0 0 13.703-1.51 14.383 14.383 0 0 0 5.19-6.947h-1.951ZM15.155 7.222c1.513 0 2.991.463 4.24 1.329a7.607 7.607 0 0 1 2.762 3.522H8.154a7.606 7.606 0 0 1 2.761-3.522 7.444 7.444 0 0 1 4.24-1.33Z"
                />
                <path
                    fill="#4C4CC5"
                    d="m17.919.736 6.534 17.375 4.527.009c.247-1.073.372-2.172.373-3.273a14.468 14.468 0 0 0-3.32-9.253l-.108-.126c-.048-.057-.098-.112-.146-.168a15.619 15.619 0 0 0-2.962-2.575A14.005 14.005 0 0 0 18.179.78l-.26-.045v.002ZM28.537 19.656h-1.955c-.509 0-1.017.021-1.523.064l1.427 3.796a14.44 14.44 0 0 0 2.05-3.86Z"
                />
            </g>
            <path
                fill={mode === 'dark' ? theme.colors.dark : '#fff'}
                d="M55.968 20.344h-2.574v-8.712l-1.98 2.034-1.458-1.53 3.78-3.798h2.232v12.006Zm6.05-3.384h-4.32v-1.944h4.32v1.944Zm6.747 3.384H66.19v-8.712l-1.98 2.034-1.458-1.53 3.78-3.798h2.232v12.006Zm1.802-5.994c0-3.096 1.53-6.192 4.968-6.192 3.42 0 4.968 3.096 4.968 6.192s-1.548 6.21-4.968 6.21c-3.438 0-4.968-3.114-4.968-6.21Zm7.326 0c0-2.214-.648-3.924-2.358-3.924-1.728 0-2.376 1.71-2.376 3.924s.648 3.942 2.376 3.942c1.71 0 2.358-1.728 2.358-3.942Z"
            />
        </svg>
    );
}
